import { Variants, motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { cn } from '../../utils/helper'
import MotionWrapper from '../MotionWrapper'

type Props = {
    label: string
    path: string
    index: number
    onClick?: () => void
    className?: string
    isActive: boolean
}

const slide: Variants = {
    initial: {
        x: '80px'
    },
    enter: (i) => ({
        x: '0px',
        transition: {
            duration: 0.8,
            ease: [0.65, 0, 0.35, 1],
            delay: 0.1 * i
        }
    }),
    exit: (i) => ({
        x: '80px',
        transition: {
            duration: 0.8,
            ease: [0.65, 0, 0.35, 1],
            delay: 0.1 * i
        }
    })
}

export const scale = {
    open: { scale: 1, opacity: 1, transition: { duration: 0.3 } },
    closed: { scale: 0, opacity: 0, transition: { duration: 0.4 } }
}

export default function AnimatedLink({ label, path, index, onClick, className, isActive }: Props) {
    return (
        <MotionWrapper custom={index} variants={slide} initial="initial" animate="enter" exit="exit">
            <Link onClick={onClick} to={path} className={cn('text-bold block text-4xl', className)}>
                <motion.div
                    variants={scale}
                    initial="closed"
                    animate={isActive ? 'open' : 'closed'}
                    className="absolute left-[-30px] top-1/2 aspect-square w-2 -translate-y-1/2 rounded-full bg-neutral-100"
                />
                {label}
            </Link>
        </MotionWrapper>
    )
}
